import { render } from "./DirectoryItem.vue?vue&type=template&id=3fcefda0&scoped=true"
import script from "./DirectoryItem.vue?vue&type=script&lang=js"
export * from "./DirectoryItem.vue?vue&type=script&lang=js"

import "./DirectoryItem.vue?vue&type=style&index=0&id=3fcefda0&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src1216986842/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fcefda0"]])

export default __exports__